/* eslint-disable sonarjs/cognitive-complexity */
import { BaSeStepper, BaSeTheme } from '@base/react';
import * as Sebrae from '@sebrae/react-core';
import React, { useCallback, useContext, useEffect } from 'react';

import { useJohariController } from '../../../../hooks/controllers/johari-controller';
import { useModuleController } from '../../../../hooks/controllers/module-public-controller';
import { Adjetivos } from './Adjetivos';
import { Avaliacao } from './Avaliacao';
import { Proximidade } from './Proximidade';
import { StepContext } from './context/StepContext';
import { useStep } from './hook/useStep';

const cache = Sebrae.StorageUtil.inTemporaryStore();

// eslint-disable-next-line sonarjs/cognitive-complexity
export const Johari = () => {
  const { numberStep, setCurrentStep, goToStage } = useContext(StepContext);
  const [dataStep, setDataStep] = React.useState([]);
  const [settings, setSettings] = React.useState({});

  // const [name, setName] = React.useState('');
  const {
    getJohariDataSteps,
    getJohariDataInterview,
    getJohariDataInterviewPublic,
  } = useJohariController();
  const { getSettingsModule } = useModuleController();
  const { getRouteParam, navigateTo } = Sebrae.useRouter();
  const { dataQueryString } = useStep();
  const [name, setName] = React.useState('');

  useEffect(() => {
    const moduleId = getRouteParam('module');
    const cpf = getRouteParam('cpf');

    if (moduleId) {
      cache.setItem(`@empretec:module`, Number(moduleId));
    }

    if (cpf) {
      getJohariDataInterviewPublic(moduleId, cpf)
        .then((response) => {
          cache.setItem(`@empretec:interview`, response?.id);
          setName(response?.candidate?.name);
          if (
            !response?.isActiveJohari ||
            response?.isActiveJohari === undefined
          ) {
            navigateTo('/candidato/questionario/link-expirado');
          }
        })
        .catch((err) => console.log(err));
    }

    getJohariDataSteps()
      .then((response) => {
        setDataStep(response);
      })
      .catch((error) => console.error(error));
  }, [
    dataQueryString,
    getRouteParam,
    getJohariDataInterview,
    getJohariDataSteps,
    navigateTo,
    getJohariDataInterviewPublic,
  ]);

  React.useEffect(() => {
    const moduleId = getRouteParam('module');

    if (moduleId) {
      getSettingsModule(+moduleId)
        .then((response) => {
          setSettings(response.settingsMap);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [getRouteParam, getSettingsModule]);

  const returnDataToStep = useCallback(
    (nameStep) => {
      const filteredData = dataStep.find((step) => step.name === nameStep);
      return filteredData;
    },
    [dataStep],
  );

  const changeStep = (step) => {
    if (step === 1) {
      setCurrentStep(1);
    }
    if (step === 2 && goToStage(1)) {
      setCurrentStep(2);
    }
    if (step === 3 && goToStage(1) && goToStage(2)) {
      setCurrentStep(3);
    }
  };

  return (
    <div>
      <BaSeStepper
        activeColor={BaSeTheme.colors.institucionais.azulSebrae75}
        incompletedColor={BaSeTheme.colors.institucionais.cinzaSebrae90}
        currentStep={numberStep}
        withTransition
        onStepChange={(e) => {
          changeStep(e);
          // if (goToStage(e)) {
          //   setCurrentStep(e);
          // }
        }}
        steps={[
          {
            title: 'Proximidade',
            content: () => (
              <Proximidade
                dataStep={returnDataToStep('PROXIMIDADE')}
                name={name}
                settings={settings}
              />
            ),
          },
          {
            title: 'Avaliação',
            content: () => (
              <Avaliacao
                dataStep={returnDataToStep('AVALIAÇÃO')}
                settings={settings}
              />
            ),
          },
          {
            title: 'Adjetivos',
            content: () => (
              <Adjetivos
                dataStep={returnDataToStep('ADJETIVOS')}
                settings={settings}
              />
            ),
          },
        ]}
      />
    </div>
  );
};
